export enum ZonesRoutesEnum {
    SMART_PREFIX = 'smart',
    SMART_ZONES = 'smart-list',
    SMART_DETAILS = 'smart-details',
}
